module.exports = __webpack_public_path__ + "media/images/icons/duotone-icons/Food/Bottle#2-bdbde7983a02651f2891bac9da8b69c0.svg";